export const getFormattedDateTime = (date) => {
  let d = new Date()
  if (date) d = new Date(date)

  const year = d.getFullYear()
  const month = ('0' + (d.getMonth() + 1)).slice(-2)
  const day = ('0' + d.getDate()).slice(-2)
  const hours = ('0' + d.getHours()).slice(-2)
  const minutes = ('0' + d.getMinutes()).slice(-2)
  const seconds = ('0' + d.getSeconds()).slice(-2)

  return year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds
}

export const calculateDateTime = (type, operation, number, date) => {
  let d = new Date()
  if (date) d = new Date(date)
  
  if (type === 'minutes') {
    if (operation === 'plus') {
      d.setMinutes(d.getMinutes() + parseInt(number))
    } else {
      d.setMinutes(d.getMinutes() - parseInt(number))
    }
  }

  if (type === 'hours') {
    if (operation === 'plus') {
      d.setHours(d.getHours() + parseInt(number))
    } else {
      d.setHours(d.getHours() - parseInt(number))
    }
  }

  if (type === 'days') {
    if (operation === 'plus') {
      d.setDate(d.getDate() + parseInt(number))
    } else {
      d.setDate(d.getDate() - parseInt(number))
    }
  }
  
  if (type === 'months') {
    if (operation === 'plus') {
      d.setMonth(d.getMonth() + parseInt(number))
    } else {
      d.setMonth(d.getMonth() - parseInt(number))
    }
  }

  if (type === 'years') {
    if (operation === 'plus') {
      d.setFullYear(d.getFullYear() + parseInt(number))
    } else {
      d.setFullYear(d.getFullYear() - parseInt(number))
    }
  }
  
  const year = d.getFullYear()
  const month = ('0' + (d.getMonth() + 1)).slice(-2)
  const day = ('0' + d.getDate()).slice(-2)
  const hours = ('0' + d.getHours()).slice(-2)
  const minutes = ('0' + d.getMinutes()).slice(-2)
  const seconds = ('0' + d.getSeconds()).slice(-2)
  
  return year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds
}

export const getTextedDate = (date) => {
  let d = new Date()
  if (date) d = new Date(date)

  const year = d.getFullYear()
  const month = ('0' + (d.getMonth() + 1)).slice(-2)
  const day = ('0' + d.getDate()).slice(-2)

  return day + '.' + month + '.' + year
}

export const getTextedDateTime = (date) => {
  let d = new Date()
  if (date) d = new Date(date)

  const year = d.getFullYear()
  const month = ('0' + (d.getMonth() + 1)).slice(-2)
  const day = ('0' + d.getDate()).slice(-2)
  const hours = ('0' + d.getHours()).slice(-2)
  const minutes = ('0' + d.getMinutes()).slice(-2)
  const seconds = ('0' + d.getSeconds()).slice(-2)

  return day + '.' + month + '.' + year + ' ' + hours + ':' + minutes + ':' + seconds
}

export const getDifferenceInDays = (date1, date2) => {
  let d1 = new Date()
  let d2 = new Date()

  if (date1) d1 = new Date(date1)
  if (date2) d2 = new Date(date2)

  const differenceInTime = d2.getTime() - d1.getTime()

  const differenceInDays = differenceInTime / (1000 * 3600 * 24)

  return Math.round(differenceInDays)
}

export const getDaysInMonth = (date) => {
  let d = new Date()
  if (date) d = new Date(date)

  let year = d.getFullYear()
  let month = d.getMonth()

  let nextMonth = new Date(year, month + 1, 1)

  nextMonth.setDate(nextMonth.getDate() - 1)

  let daysInMonth = nextMonth.getDate()

  return daysInMonth
}

export const getDaysInYear = (date) => {
  let year = new Date().getFullYear()
  if (date) year = new Date(date).getFullYear()

  const isLeapYear = (year % 4 === 0 && year % 100 !== 0) || (year % 400 === 0)

  const daysInYear = isLeapYear ? 366 : 365

  return daysInYear
}

export const getIsoDateTime = (date) => {
  let d = new Date()
  if (date) d = new Date(date)

  const year = d.getFullYear()
  const month = ('0' + (d.getMonth() + 1)).slice(-2)
  const day = ('0' + d.getDate()).slice(-2)
  const hours = ('0' + d.getHours()).slice(-2)
  const minutes = ('0' + d.getMinutes()).slice(-2)
  const seconds = ('0' + d.getSeconds()).slice(-2)

  return year + '-' + month + '-' + day + 'T' + hours + ':' + minutes + ':' + seconds + 'Z'
}